import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import CategoryListItem from '../category-list-item';
import styles from './category-list.scss';

const getMaxColumnsClass = listLength => {
  switch (listLength) {
    case 1:
      return styles.maxColumns1;
    case 2:
      return styles.maxColumns2;
    case 3:
      return styles.maxColumns3;
    case 4:
      return styles.maxColumns4;
    default:
      return styles.maxColumns5;
  }
};

const CategoryList = ({ categories = [] }) => {
  //this line is good for debugging different number of items
  // categories = categories.concat(categories).concat(categories).slice(0, 2);
  return (
    <div className={styles.container}>
      <ul className={classNames(styles.list, 'category-list__list')}>
        {categories.map((category, index) =>
          <li
            className={classNames(styles.listItem, getMaxColumnsClass(categories.length), 'category-list__list-item')}
            key={index}
          >
            <CategoryListItem category={category}/>
          </li>
        )}
      </ul>
    </div>
  );
};

CategoryList.propTypes = {
  categories: PropTypes.array,
};

export default CategoryList;



// WEBPACK FOOTER //
// ./app/components/category-list/category-list.js